var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesTransportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3895_2655)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3895_2655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 19.375V0.625H1.125V19.375H19.875Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3895_2655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4036 14.3932H19.9141V8.74475C19.9141 6.31842 17.9471 4.35151 15.5208 4.35151H2.34113C2.1763 4.35147 2.01308 4.38393 1.8608 4.44703C1.70853 4.51014 1.57019 4.60266 1.45371 4.71928C1.33708 4.83576 1.24456 4.97409 1.18145 5.12637C1.11834 5.27864 1.08589 5.44187 1.08594 5.6067V14.3932H3.59633",
    stroke: "#707170",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47919 8.74478H9.87243V4.35154H5.47919V8.74478Z",
    stroke: "#707170",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47918 4.35154H2.34117C1.64797 4.35154 1.08594 4.91357 1.08594 5.60673V8.74478H5.47918V4.35154Z",
    stroke: "#707170",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87241 8.74478H14.2656V4.35154H9.87241V8.74478Z",
    stroke: "#707170",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9141 8.74481C19.9141 6.31848 17.9471 4.35157 15.5208 4.35157H14.2656V8.74481L19.9141 10.6276V8.74481Z",
    stroke: "#707170",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85155 13.1379C5.5444 13.1379 6.10674 13.7003 6.10674 14.3931C6.10674 15.086 5.5444 15.6484 4.85155 15.6484C4.15866 15.6484 3.59631 15.086 3.59631 14.3931C3.59631 13.7003 4.15866 13.1379 4.85155 13.1379Z",
    stroke: "#707170",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1484 13.1379C16.8413 13.1379 17.4037 13.7003 17.4037 14.3931C17.4037 15.086 16.8413 15.6484 16.1484 15.6484C15.4556 15.6484 14.8932 15.086 14.8932 14.3931C14.8932 13.7003 15.4556 13.1379 16.1484 13.1379Z",
    stroke: "#707170",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10675 14.3932H14.8932",
    stroke: "#707170",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3895_2655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesTransportIcon);
export default __webpack_public_path__ + "static/media/services-transport-icon.29e81471.svg";
export { ForwardRef as ReactComponent };